/**
 * Resets the student main pane scroll (and window fallback) to the top.
 * The student shell scrolls inside `.side-content`, not the document.
 */
export function scrollStudentContentToTop() {
  if (typeof document !== "undefined") {
    const content = document.querySelector(".side-content");
    if (content) {
      if (typeof content.scrollTo === "function") {
        content.scrollTo({ top: 0, left: 0, behavior: "auto" });
      } else {
        content.scrollTop = 0;
      }
    }
    if (document.documentElement) {
      document.documentElement.scrollTop = 0;
    }
    if (document.body) {
      document.body.scrollTop = 0;
    }
  }

  if (typeof window === "undefined" || typeof window.scrollTo !== "function") {
    return;
  }

  // jsdom exposes scrollTo but logs "Not implemented"; skip it in that environment.
  const userAgent = typeof navigator !== "undefined" ? String(navigator.userAgent || "") : "";
  if (/jsdom/i.test(userAgent)) {
    return;
  }

  try {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  } catch {
    /* ignore unsupported scroll environments */
  }
}
